import React from "react";
import { Radio as MUIRadio, FormControlLabel, useTheme } from "@mui/material";
import Typography from "../typography";

interface RadioProps {
  isSelected: boolean;
  disabled?: boolean;
  onChange: (selected: boolean) => void;
  label: string;
  labelPlacement?: "start" | "end" | "top" | "bottom";
  value?: string;
  textboxBackgroundColor?: string;
}

const Radio: React.FC<RadioProps> = ({
  isSelected,
  onChange,
  label,
  disabled = false,
  labelPlacement = "end",
  value,
  textboxBackgroundColor = "#fff",
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };
  const theme = useTheme();

  return (
    <FormControlLabel
      control={
        <MUIRadio
          style={{ padding: theme.spacing(0.5) }}
          size="small"
          checked={isSelected}
          onChange={handleChange}
          value={value}
          sx={{
            color: textboxBackgroundColor,
            "&.Mui-checked": {
              color: theme.palette.warning.main,
            },
          }}
        />
      }
      label={
        <Typography variant="body2" style={{ fontWeight: 400 }}>
          {label}
        </Typography>
      }
      disabled={disabled}
      labelPlacement={labelPlacement}
    />
  );
};

export default Radio;
